import { TableCell } from '@mui/material';
import styled from 'styled-components';

const StyledHeaderTableCell = styled(TableCell)`
  color: ${({ theme }) => theme.palette.grey[500]};
`;

export default StyledHeaderTableCell;
